import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonUtilityLib } from '@thehubz/client/core';
import { Subscription, filter } from 'rxjs';
import { AssetCommonService } from '../../../services/asset-common.service';
import { AssetViewComponent } from '../asset-info/components/asset-view/asset-view.component';
import { AssetFileInfoComponent } from './asset-file-info/asset-file-info.component';

@Component({
  selector: 'thehubz-asset-data',
  templateUrl: './asset-data.component.html',
  styleUrls: ['./asset-data.component.scss'],
  standalone: true,
  imports: [CommonModule, AssetViewComponent, AssetFileInfoComponent],
})
export class AssetDataComponent implements OnInit, OnDestroy {
  assetInfo!: any;
  assetDataSubjectSubscription: Subscription | undefined;
  constructor(private assetCommonService: AssetCommonService, private commonUtilityLib: CommonUtilityLib) {}

  ngOnInit(): void {
    this.assetDataSubjectSubscription = this.assetCommonService.assetDataSubject$
      .pipe(filter((asset) => !this.commonUtilityLib.isEmptyObject(asset)))
      .subscribe((data) => {
        this.assetInfo = data;
      });
  }

  ngOnDestroy(): void {
    if (this.assetDataSubjectSubscription) this.assetDataSubjectSubscription.unsubscribe();
  }
}
